import { apiEndpoints, apiParams, RoutingConstants } from "../constants";
import { deleteRequest, getRequest, postRequest, putRequest } from "./requests";
import { eventChannel } from "redux-saga";

export const fetchTiersJobId = async (id) => {
  const { baseUrl, eventShiftRole } = apiEndpoints;
  const { generateTiers } = RoutingConstants;

  const generateUrl = `${baseUrl}${eventShiftRole}/${id}${generateTiers}`;
  try {
    const response = await postRequest({ url: generateUrl });
    return response;
  } catch (error) {
    return error;
  }
};

export const fetchTiers = async (id) => {
  const { baseUrl } = apiEndpoints;
  const { getTiersJobStatus } = RoutingConstants;
  return eventChannel((emit) => {
    const url = `${baseUrl}${getTiersJobStatus}/${id}`;
    const source = new EventSource(url);

    source.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);

        if (data.status === "processing") {
          emit({ type: "processing", data });
        } else if (data.status === "completed") {
          emit({ type: "completed", data });
        } else if (data.status === "failed") {
          emit({ type: "failed", data });
        }
      } catch (err) {
        emit({ type: "error", error: err });
      }
    };

    source.onerror = (err) => {
      emit({ type: "error", error: err });
    };

    return () => {
      source.close();
    };
  });
}

export const fetchRoleInviteData = async (id) => {
  const { baseUrl, eventShiftRole, addPerson } = apiEndpoints;
  const { listType } = apiParams;

  const inviteDataUrl = `${baseUrl}${eventShiftRole}${addPerson}/${id}?${listType}=with_token`;
  try {
    const response = await getRequest(inviteDataUrl);
    return response;
  } catch (error) {
    return error;
  }
}

export const fetchInviteTemplate = async (payload) => {
  const { baseUrl, template } = apiEndpoints;
  const { render } = RoutingConstants;

  const { data, slug } = payload;

  try {
    const url = `${baseUrl}${template}/${slug}${render}`;
    const response = await postRequest({ url: url, payload: { data: data } });
    return response;
  } catch (error) {
    return error;
  }
}

export const getSearchObjectByRoleUUID = async (roleUUID) => {
  const { baseUrl } = apiEndpoints;

  const url = `${baseUrl}/v1/event/shift/role/${roleUUID}/search-object`;

  try {
    return await getRequest(url);
  } catch (error) {
    return error;
  }
};

export const searchPeopleByPayload = async (payload = {}) => {
  const { baseUrl, talentFilter } = apiEndpoints;
  const { listType, pageNumber, pageSize, condensedType } = apiParams;

  const { number, size } = payload;

  const bodyPayload = { ...payload };
  delete bodyPayload.number;
  delete bodyPayload.size;

  const url = `${baseUrl}${talentFilter}?${listType}=${condensedType}&${pageNumber}=${number}&${pageSize}=${size}`;
  try {
    return await postRequest({
      url,
      payload: bodyPayload.data,
    });
  } catch (error) {
    return error;
  }
};

export const shortlistPerson = async (data) => {
  const { baseUrl, eventShiftRolePerson } = apiEndpoints;
  const url = `${baseUrl}${eventShiftRolePerson}`;
  try {
    return await postRequest({
      url,
      payload: data,
    });
  } catch (error) {
    return error;
  }
}

export const deleteShortlistedPerson = async (uuid) => {
  const { baseUrl, eventShiftRolePerson } = apiEndpoints;
  const url = `${baseUrl}${eventShiftRolePerson}/${uuid}`;
  try {
    return await deleteRequest(url);
  } catch (error) {
    return error;
  }
}

export const updateShortlistedPersonStatus = async (payload) => {
  const { baseUrl, eventShiftRolePerson } = apiEndpoints;
  const url = `${baseUrl}${eventShiftRolePerson}`;
  try {
    return await putRequest({ url, payload });
  } catch (error) {
    return error;
  }
}

export const triggerInviteToTalent = async (inviteData) => {
  const { baseUrl, emailSendJob } = apiEndpoints;
  const url = `${baseUrl}${emailSendJob}`;
  try {
    return await postRequest({
      url,
      payload: inviteData,
    });
  } catch (error) {
    return error;
  }
}

export const updateTalentAcceptedStatus = async (token) => {
  const { baseUrl, eventShiftRolePerson } = apiEndpoints;
  const { accepted } = RoutingConstants.tiers;
  const url = `${baseUrl}${eventShiftRolePerson}${accepted}?token=${token}`
  try {
    return await postRequest({ url });
  } catch (error) {
    return error;
  }
}

export const updateTalentRejectedStatus = async (token) => {
  const { baseUrl, eventShiftRolePerson } = apiEndpoints;
  const { denied } = RoutingConstants.tiers;
  const url = `${baseUrl}${eventShiftRolePerson}${denied}?token=${token}`
  try {
    return await postRequest({ url });
  } catch (error) {
    return error;
  }
}

export const updateTalentUnsubscribedStatus = async (token) => {
  const { baseUrl, person } = apiEndpoints;
  const { unsubscribe } = RoutingConstants.tiers;
  const url = `${baseUrl}${person}${unsubscribe}?token=${token}`
  try {
    return await postRequest({ url });
  } catch (error) {
    return error;
  }
}

export const updateTalentWaitlistedStatus = async (token) => {
  const { baseUrl, eventShiftRolePerson } = apiEndpoints;
  const { backup } = RoutingConstants.tiers;
  const url = `${baseUrl}${eventShiftRolePerson}${backup}?token=${token}`
  try {
    return await postRequest({ url });
  } catch (error) {
    return error;
  }
}

export const deleteOutstandingInvite = async (uuid) => {
  const { baseUrl, outstandingJob } = apiEndpoints;
  const url = `${baseUrl}${outstandingJob}/${uuid}`;
  try {
    return await deleteRequest(url);
  } catch (error) {
    return error;
  }
}
